import { FETCH_VIDEOS } from './constants'
import { take, call, put, select } from 'redux-saga/effects'
import { apiFetchVideos } from './services'
import { fetchVideos } from './actions'
import languages from '../../constants/languages'
import { slugify } from '../../helpers/utils'

function* fetchVideoWorker(currentPhoneId) {
  const state = yield select()
  const preSaleFlag = state.devicebits.preSaleFlag
  const language = languages[state.devicebits.language]
  const customer = state.devicebits.customer
  const response = yield call(
    apiFetchVideos,
    currentPhoneId,
    preSaleFlag,
    language,
    customer
  )

  if (Array.isArray(response)) {
    const videos = addSlugs(response)
    yield put(fetchVideos.success(videos, currentPhoneId))
  }
}

const addSlugs = videoResponse => (
  videoResponse.map(video => ({
    ...video,
    slug: slugify(video.title)
  }))
)

export default function* watcher() {
  while (true) {
    let payload = yield take(FETCH_VIDEOS.REQUEST)
    yield call(fetchVideoWorker, payload.currentPhoneId)
  }
}



// WEBPACK FOOTER //
// ./src/containers/Videos/sagas.js